import { Input } from 'antd'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import './LonLatInput.scss'

// 格式化度°
const formateDegree = (type, degree) => {
    const maxLon = 180
    const minLon = -180
    const maxLat = 90
    const minLat = -90
    if (!degree) return '0'
    if (type === 'longitude') {
        if (degree > maxLon) return maxLon
        if (degree < minLon) return Math.abs(minLon)
    }
    if (type === 'latitude') {
        if (degree > maxLat) return maxLat
        if (degree < minLat) return Math.abs(minLat)
    }
    if (/[ewsnEWSN.]/.test(degree)) return '0'
    if (degree.includes('-')) {
        let count = degree.split('-').length - 1
        if (count > 1) return '0'
        if (count === 1 && degree.indexOf('-') !== 0) return '0'
    }
    return Math.abs(degree).toString()
}
// 格式化分'
const formateMinute = minute => {
    if (!minute) return '00'
    if (minute > 59) return 59
    if (minute < 0) return 0
    if (minute < 10 && minute >= 0) return minute.padStart(2, '0')
    if (/[-ewsnEWSN.]/.test(minute)) return '00'
    return minute
}
// 格式化秒"
const formateSecond = second => {
    let max = 59
    let min = 0
    if (!second) return '00.0000'
    if (second > max) return max.toFixed(4)
    if (second < 0) return min.toFixed(4)
    if (/[-ewsnEWSN]/.test(second)) return '00.0000'
    if (second === '0.0000' || second === '00.0000') return '00.0000'
    return Number(second).toFixed(4)
}
// 处理经纬度方位
const handleDirection = (type, degree) => {
    let direction = ''
    if (type === 'longitude' && degree >= 0) {
        direction = 'E'
    } else if (type === 'longitude' && degree < 0) {
        direction = 'W'
    } else if (type === 'latitude' && degree >= 0) {
        direction = 'N'
    } else if (type === 'latitude' && degree < 0) {
        direction = 'S'
    }
    return direction.toUpperCase()
}

// 错误提示
const handleErr = (degree, minute, second) => {
    if (degree === '0' && minute === '00' && second === '00.0000') {
        return true
    } else if (degree === '0' && minute === '00' && second === '0.0000') {
        return true
    } else {
        return false
    }
}

export const LonLatInput = ({ value, onChange, type }) => {
    const [inputValue, setInputValue] = useState('')
    const [isRed, setIsRed] = useState(false)

    const handleFn = e => {
        let degree = ''
        let minute = ''
        let second = ''
        let direction = ''
        let result = ''

        let str = e.target.value
        if (!str) return setInputValue('')
        let str1 = ''
        if (type === 'longitude') {
            str1 = str.replace(/[^0-9°'".\-ewEW\s+]/g, '') // 去掉不要的字母
        } else if (type === 'latitude') {
            str1 = str.replace(/[^0-9°'".\-snSN\s+]/g, '') // 去掉不要的字母
        }
        let str2 = str1.replace(/\s+/g, ' ') // 将字符串中每处多个空格替换成一个空格
        let str3 = str2.trim() // 去掉字符串中的前后空格
        let isNot = !str3.includes('°') && !str3.includes("'") && !str3.includes('"')
        let isAll = str3.includes('°') && str3.includes("'") && str3.includes('"')
        let arr = str3.split(' ') // 以空格分隔，取出度、分、秒

        if (arr.length === 4) {
            // 有输入方位时，取用户输入的方位（注意：当用户输入方位与度数不统一时，以方位为判断依据，度数要取正数，因为正负号已经转换为EW）
            direction = arr[3]?.toUpperCase()
            // 方位输入进行限制，经度只能输入ewEW,纬度只能输入snSN
            if (type === 'longitude') {
                direction = direction?.replace(/[^EW]/g, '')
            } else if (type === 'latitude') {
                direction = direction?.replace(/[^SN]/g, '')
            }

            if (isNot) {
                degree = formateDegree(type, arr[0])
            } else if (isAll) {
                let d = arr[0].substring(0, arr[0].length - 1)
                degree = formateDegree(type, d)
            } else {
                degree = '0'
            }

            if (Math.abs(Number(degree)) === 180 && type === 'longitude') {
                minute = formateMinute(0)
                second = formateSecond(0)
            } else if (Math.abs(Number(degree)) === 90 && type === 'latitude') {
                minute = formateMinute(0)
                second = formateSecond(0)
            } else {
                if (isNot) {
                    minute = formateMinute(arr[1])
                    second = formateSecond(arr[2])
                } else if (isAll) {
                    let m = arr[1].substring(0, arr[1].length - 1)
                    let s = arr[2].substring(0, arr[2].length - 1)
                    minute = formateMinute(m)
                    second = formateSecond(s)
                } else {
                    minute = '00'
                    second = '00.0000'
                }
            }
            setIsRed(handleErr(degree, minute, second))
            result = `${degree}° ${minute}' ${second}" ${direction}`
            setInputValue(result)
        } else if (arr.length === 3) {
            // 没有输入方位时，根据经纬度数正负来判断方位（注意度数需要传未格式化的度数）
            if (isNot) {
                direction = handleDirection(type, arr[0])
                degree = formateDegree(type, arr[0])
            } else if (isAll) {
                let d = arr[0].substring(0, arr[0].length - 1)
                direction = handleDirection(type, d)
                degree = formateDegree(type, d)
            } else {
                degree = '0'
                direction = handleDirection(type, degree)
            }

            if (Math.abs(Number(degree)) === 180 && type === 'longitude') {
                minute = formateMinute(0)
                second = formateSecond(0)
            } else if (Math.abs(Number(degree)) === 90 && type === 'latitude') {
                minute = formateMinute(0)
                second = formateSecond(0)
            } else {
                if (isNot) {
                    minute = formateMinute(arr[1])
                    second = formateSecond(arr[2])
                } else if (isAll) {
                    let m = arr[1].substring(0, arr[1].length - 1)
                    let s = arr[2].substring(0, arr[2].length - 1)
                    minute = formateMinute(m)
                    second = formateSecond(s)
                } else {
                    minute = '00'
                    second = '00.0000'
                }
            }
            setIsRed(handleErr(degree, minute, second))
            result = `${degree}° ${minute}' ${second}" ${direction}`
            setInputValue(result)
        } else if (arr.length === 2) {
            // 没有输入方位时，根据经纬度数正负来判断方位（注意度数需要传未格式化的度数）
            if (isNot) {
                direction = handleDirection(type, arr[0])
                degree = formateDegree(type, arr[0])
            } else if (isAll) {
                let d = arr[0].substring(0, arr[0].length - 1)
                direction = handleDirection(type, d)
                degree = formateDegree(type, d)
            } else {
                degree = '0'
                direction = handleDirection(type, degree)
            }

            if (Math.abs(Number(degree)) === 180 && type === 'longitude') {
                minute = formateMinute(0)
                second = formateSecond(0)
            } else if (Math.abs(Number(degree)) === 90 && type === 'latitude') {
                minute = formateMinute(0)
                second = formateSecond(0)
            } else {
                if (isNot) {
                    minute = formateMinute(arr[1])
                    second = formateSecond(0)
                } else if (isAll) {
                    let m = arr[1].substring(0, arr[1].length - 1)
                    minute = formateMinute(m)
                    second = formateSecond(0)
                } else {
                    minute = '00'
                    second = '00.0000'
                }
            }
            setIsRed(handleErr(degree, minute, second))
            result = `${degree}° ${minute}' ${second}" ${direction}`
            setInputValue(result)
        } else if (arr.length === 1) {
            // 没有输入方位时，根据经纬度数正负来判断方位（注意度数需要传未格式化的度数）
            direction = handleDirection(type, arr[0])
            degree = formateDegree(type, arr[0])
            minute = '00'
            second = '00.0000'
            setIsRed(handleErr(degree, minute, second))
            result = `${degree}° ${minute}' ${second}" ${direction}`
            setInputValue(result)
        } else {
            direction = handleDirection(type, 0)
            degree = '0'
            minute = '00'
            second = '00.0000'
            setIsRed(handleErr(degree, minute, second))
            result = `${degree}° ${minute}' ${second}" ${direction}`
            setInputValue(result)
        }
    }
    // 键盘按下
    const handleKeyPress = e => {
        setIsRed(false)
        if (e.key === 'Enter') {
            handleFn(e)
        }
    }
    // 失去焦点
    const handleOnBlur = e => {
        setIsRed(false)
        handleFn(e)
    }
    const handleChange = e => {
        const result = e.target.value
        setInputValue(result)
    }

    useEffect(() => {
        setInputValue(value)
    }, [])

    useEffect(() => {
        onChange(inputValue)
    }, [inputValue])
    return (
        <Input
            className={['lonLatInput', 'keepRight', isRed ? 'isRed' : null]}
            style={{ color: isRed ? 'red' : '#344050' }}
            placeholder={t('common.tipsLonLat')}
            value={inputValue}
            allowClear={false}
            onKeyPress={handleKeyPress}
            onBlur={handleOnBlur}
            onChange={handleChange}
        />
    )
}
